export default __webpack_public_path__ + "static/media/3-Tiers.79570b56.svg";